
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiResetPassword } from '@/api/setting'
import { apiLogout } from '@/api/app'


@Component
export default class ListsDetail extends Vue {
  /** S Data **/

  // เพิ่มข้อมูลแบบฟอร์มร้านค้า
  form: any = {
    origin_password: '', // รหัสผ่านเดิม
    password_confirm: '', // รหัสผ่านใหม่
    password: '' // ยืนยันรหัสผ่าน
  };

  // การตรวจสอบแบบฟอร์ม
  rules = {
    origin_password: [{ required: true, message: 'กรุณากรอกรหัสผ่านเดิม', trigger: 'blur' }],
    password_confirm: [
      { required: true, message: 'กรุณากรอกรหัสผ่าน', trigger: 'blur' },
      {
        validator: (rule: object, value: string, callback: any) => {
          !value
            ? callback(new Error('กรุณากรอกรหัสผ่าน'))
            : callback()
        },
        trigger: 'blur'
      }
    ],
    password: [
      { required: true, message: 'กรุณากรอกรหัสผ่านอีกครั้ง', trigger: 'blur' },
      {
        validator: (rule: object, value: string, callback: any) => {
          if (this.form.password_confirm) {
            if (!value) callback(new Error('กรุณากรอกรหัสผ่านอีกครั้ง'))
            if (value !== this.form.password_confirm) callback(new Error('รหัสผ่านที่ป้อนสองครั้งไม่สอดคล้องกัน!'))
          }
          callback()
        },
        trigger: 'blur'
      }
    ]
  };

  /** E Data **/

  /** S Methods **/
  // คลิกเพื่อส่งแบบฟอร์ม
  onSubmit (formName: string) {
    // ตรวจสอบว่ารูปแบบแบบฟอร์มถูกต้อง
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      this.handleEdit()
    })
  }

  async handleEdit () {
    await apiResetPassword({ ...this.form })
    this.logout()
  }

  logout () {
    apiLogout().then(() => {
      this.$store.commit('setUserInfo', {})
      this.$store.commit('setPermission', {})
      this.$router.push('/account/login')
    })
  }
  /** E Methods **/
}
